import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getAxiosClient } from '@/api/axios-client'

import { useIndividualsServiceGetV1IndividualsByIndividualIdKey } from '../client/queries/common'

type PreCheckResponse = {
  status?: 'pending' | 'passed' | 'warning'
  results?: { warnings: ('missing_person' | 'missing_pages')[] } | null
}

export const useRunPreChecks = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      individualId,
      documentId,
    }: {
      individualId: string
      documentId: string
    }): Promise<PreCheckResponse> => {
      const client = getAxiosClient()
      const res = await client.post<PreCheckResponse>(
        `/v1/individuals/${individualId}/documents/${documentId}/pre-checks`,
      )
      return res.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey],
      })
    },
  })
}
